// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"adf5f7ca","404":"d8ad8c6b","637":"37ef54da","877":"5dc70fdf"}[chunkId] + ".css";
};